document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initParallaxHero();
  initResenasCarrusel();
});

// ---------- Reveal on scroll (compartido por toda la web) ----------
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

// ---------- Parallax suave del hero (transform, no background-attachment) ----------
function initParallaxHero() {
  var wraps = document.querySelectorAll('.mt-hero-wrap[data-parallax]');
  if (!wraps.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function update() {
    wraps.forEach(function (wrap) {
      var intensity = parseFloat(wrap.getAttribute('data-parallax')) || 0;
      if (!intensity) return;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (rect.top) / vh; // ~1 cuando entra por abajo, ~0 centrado, negativo al salir
      var offset = progress * intensity * -40;
      wrap.style.setProperty('--mt-parallax-y', offset + 'px');
    });
    ticking = false;
  }
  document.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
  update();
}

// ---------- Carrusel infinito de reseñas (CSS transform, sin librerías) ----------
function initResenasCarrusel() {
  var wraps = document.querySelectorAll('.mt-resenas-track-wrap');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.mt-resenas-track');
    if (!track || track.dataset.mtInit) return;
    track.dataset.mtInit = '1';

    // Duplica el contenido una vez para el bucle continuo
    var original = Array.prototype.slice.call(track.children);
    if (!original.length) return;
    original.forEach(function (node) {
      track.appendChild(node.cloneNode(true));
    });

    var speed = parseFloat(wrap.getAttribute('data-velocidad')) || 40; // px/seg
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var pos = 0;
    var last = null;
    var paused = false;
    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () { paused = false; });

    function frame(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000;
      last = ts;
      if (!paused) {
        pos -= speed * dt;
        var half = track.scrollWidth / 2;
        if (half > 0 && Math.abs(pos) >= half) pos += half;
        track.style.transform = 'translateX(' + pos + 'px)';
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  });
}
